export default __webpack_public_path__ + "static/media/google-podcast.7b91d9b3.png";